import React from 'react';

import Icon from '../Icon/Icon';

const TipsIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <path
                d='M31.3418 18C31.3418 14.1341 28.2077 11 24.3418 11'
                stroke='#00D1D2'
                strokeWidth='2'
                strokeLinecap='round'
            />
            <path d='M21 40H27' stroke='#393E44' strokeWidth='2' strokeLinecap='round' />
            <path
                d='M30 28.2211L29.4538 27.3834L29 27.6793V28.2211H30ZM18 28.2211H19V27.6793L18.5462 27.3834L18 28.2211ZM34 19C34 22.5095 32.1929 25.5975 29.4538 27.3834L30.5462 29.0587C33.8275 26.9193 36 23.2136 36 19H34ZM24 9C29.5228 9 34 13.4771 34 19H36C36 12.3726 30.6274 7 24 7V9ZM14 19C14 13.4771 18.4771 9 24 9V7C17.3726 7 12 12.3726 12 19H14ZM18.5462 27.3834C15.8071 25.5975 14 22.5095 14 19H12C12 23.2136 14.1725 26.9193 17.4538 29.0587L18.5462 27.3834ZM19 30V28.2211H17V30H19ZM23 34C20.7909 34 19 32.2091 19 30H17C17 33.3137 19.6863 36 23 36V34ZM25 34H23V36H25V34ZM29 30C29 32.2091 27.2091 34 25 34V36C28.3137 36 31 33.3137 31 30H29ZM29 28.2211V30H31V28.2211H29Z'
                fill='#393E44'
            />
        </Icon>
    );
};

export default TipsIcon;
